<template>
  <b-card class="content-box">
    <div>
      <el-select
        v-model="jobStateValue"
        placeholder="请选择在岗状态"
        clearable
      >
        <el-option
          v-for="item in jobStateOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button
        type="primary"
        @click="screening"
      >筛选</el-button>

      <el-button
        v-if="checkStatus === 0 || checkStatus === 3"
        type="primary"
        style="margin: 0 0 15px 0;float:right"
        @click="updateToSchool"
      >提交至学校审核</el-button>
      <el-button
        v-if="checkStatus === 0 || checkStatus === 3"
        type="primary"
        style="margin: 0 15px 15px 0;float:right"
        @click="oneIssue"
      >一键发放</el-button>
      <p v-if="checkStatus === 3&&rejectReason">
        驳回理由：{{ rejectReason }}
      </p>
    </div>
    <div>
      <el-table
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column
          type="index"
          label="序号"
        />
        <el-table-column
          prop="studentName"
          label="申请人"
        />
        <el-table-column
          prop="applicationStatus"
          label="在岗状态"
        />
        <el-table-column
          prop="firedDate"
          label="解聘时间"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.applicationStatus === '解聘'">{{ scope.row.firedDate | moment('YYYY-MM-DD') }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="sn"
          label="学号"
        />
        <el-table-column
          prop="yearMonthStr"
          label="统计年月"
        />
        <!-- <el-table-column prop="timeStr" label="工作时间段">
        </el-table-column> -->
        <el-table-column
          prop="hourMoney"
          label="月薪"
        />
        <!-- <el-table-column label="当月工作时长">
          <template slot-scope="scope">
            <el-input v-if="checkStatus === 0" v-model="scope.row.hours" style="width: 100px" @input="hoursChanges(scope.row)"></el-input>
            <span v-else>{{scope.row.hours}}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="月工资上限">
          <template slot-scope="scope">
            <span>{{ scope.row.monthMoneyCap&&scope.row.monthMoneyCap!=='null'&&scope.row.monthMoneyCap!==''?scope.row.monthMoneyCap:'--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="拟发放工资">
          <template slot-scope="scope">
            <el-input
              v-if="checkStatus===0||checkStatus===3"
              v-model="scope.row.submitMoney"
              :class="{'redcolor':scope.row.monthMoneyCap !== null && Number(scope.row.submitMoney) > Number(scope.row.monthMoneyCap)}"
              style="width: 100px"
              maxlength="8"
            />
            <span v-else>{{ scope.row.submitMoney?scope.row.submitMoney:'--' }}</span>
          </template>
          <!-- <template slot-scope="scope">
            <span v-if="scope.row.monthMoneyCap !== null && scope.row.monthMoneyCap < Number(scope.row.hours) * scope.row.hourMoney" style="color: red">{{scope.row.submitMoney}}</span>
            <span v-else>{{scope.row.submitMoney}}</span>
          </template> -->
        </el-table-column>
        <el-table-column label="实际发放工资">
          <template slot-scope="scope">
            <span v-if="scope.row.realMoney === null"> -- </span>
            <span v-else>{{ scope.row.realMoney }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="一键发放工资"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <el-input
        v-model="wageInput"
        placeholder="请输入发放工资"
        onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
        maxlength="5"
      />
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="wageSubmit"
        >确 定</el-button>
      </span>
    </el-dialog>
  </b-card>
</template>

<script>
import { salaryService } from '@/api/index'
import { intZ } from '@/tool/utils'

export default {
  name: 'UnitProvideDetail',
  data() {
    return {
      wageInput: '',
      dialogVisible: false,
      submitMoneyIsLimit: false,
      tableData: [],
      jobId: null,
      getTime: null,
      rejectReason: '', // 驳回理由
      checkStatus: 0,
      jobStateValue: '',
      jobStateOptions: [
        {
          value: 0,
          label: '初始',
        },
        {
          value: 1,
          label: '拒绝',
        },
        {
          value: 2,
          label: '工作中',
        },
        {
          value: 3,
          label: '解聘',
        },
      ],
    }
  },
  created() {
    this.jobId = this.$route.query.jobId
    this.getTime = this.$route.query.getTime
    this.queryTableData()
  },
  methods: {
    // eslint-disable-next-line consistent-return
    updateToSchool() {
      // debugger
      const params = {
        jobId: this.jobId,
        time: this.getTime,
        list: [],
      }
      let flag = false
      const errList = []
      this.tableData.forEach((x, index) => {
        if (intZ(x.submitMoney)) {
          if (x.monthMoneyCap !== null && x.monthMoneyCap < Number(x.submitMoney)) {
            flag = true
            errList.push(index + 1)
          } else {
            const p = {
              submitMoney: x.submitMoney,
              id: x.id,
              hours: Number(x.hours),
            }
            params.list.push(p)
          }
        } else {
          flag = true
          errList.push(index + 1)
        }
      })
      if (flag) {
        let Str = ''
        errList.forEach((x, index) => {
          if (errList.length === index + 1) {
            Str += x
          } else {
            Str += `${x},`
          }
        })
        this.$message.warning(`第${Str}行填入数据需是正整数（可含零）或拟发放工资超过月工资上限,请正确填写后提交`)
        return false
      }
      salaryService()._submitSalaryToSchool(params).then(res => {
        if (res.status) {
          this.queryTableData()
        }
      })
    },
    // 拟发放工资改变
    // submitMoneyChanges(row) {
    // if (row.monthMoneyCap !== null && Number(row.submitMoney) > Number(row.monthMoneyCap)) {
    //   this.submitMoneyIsLimit = true
    //   this.$message.warning('拟发放工资超过月工资上限请重新录入')
    // } else {
    //   this.submitMoneyIsLimit = false
    // }
    // },
    hoursChanges(row) {
      row.hours = row.hours.trim()
      if (intZ(row.hours)) {
        row.submitMoney = Number(row.hours) * row.hourMoney
      } else {
        row.submitMoney = null
      }
    },
    queryTableData() {
      const params = {
        jobId: this.jobId, type: 1, time: this.$route.query.getTime, applicationStatus: this.jobStateValue,
      }
      salaryService()._studentSalaryList(params).then(res => {
        if (res.status) {
          this.tableData = res.data.list
          this.checkStatus = res.data.checkStatus
          this.rejectReason = res.data.rejectReason ? res.data.rejectReason : '无'
        }
      })
    },
    // 筛选
    screening() {
      this.queryTableData()
    },
    // 一键发放
    oneIssue() {
      this.dialogVisible = true
      this.wageInput = ''
    },
    wageSubmit() {
      this.tableData.forEach(item => {
        item.submitMoney = this.wageInput
      })
      this.dialogVisible = false
      this.$message.success('一键发放成功')
    },
  },
}
</script>

<style>

</style>
